import React from 'react';

import { Button } from '@components/Button';
import { Layout } from '@components/Layout';
import { useUser } from '@hooks/queries/useUser';
import { UserHelper } from '@models/User';
import { AuthManager } from '@store/AuthManager';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { createStrings } from '@utils/local';
import { url } from '@utils/pages';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';

const strings = createStrings({
  ja: {
    notAuthorized: (name?: string | null) => (
      <>
        <b>{name || 'あなた'}</b>
        はこのページにアクセスできません。
      </>
    ),
    login: '別のユーザーとしてログイン',
    return: 'ホームへ',
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  container: {
    ...common.flexColumnCenter,
    ...common.biggerText,
    flex: 1,
    rowGap: '1rem',
    padding: '1rem',
  },
}));

export const NotAuthorized: React.FC = observer(() => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const user = useUser(undefined, {
    enabled: AuthManager.shared.isLoggedIn,
  });

  return (
    <Layout title="アクセス拒否">
      <div className={classes.container}>
        <div>{strings.notAuthorized(user.data && new UserHelper(user.data).fullname)}</div>

        <div className={clsx(classes.flexInline, classes.horizontalSpace1)}>
          <Link to={url('/admin/auth/Login')}>
            <Button text={strings.login} color="primary" shape="round" />
          </Link>

          <Link to={url('/utilities/Dashboard')}>
            <Button text={strings.return} color="default" shape="round" />
          </Link>
        </div>
      </div>
    </Layout>
  );
});
